import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/speciality/speciality-7.jpg",
  "./img/speciality/speciality-1.jpg",
  "./img/speciality/speciality-3.jpg",
  "./img/speciality/speciality-4.jpg",
  "./img/speciality/speciality-9.jpg",
  "./img/speciality/speciality-6.jpg",
  "./img/speciality/speciality-2.jpg",
  "./img/speciality/speciality-12.jpg",
  "./img/speciality/speciality-5.jpg",
];

const FotogalerieSpeciality: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Naše speciality | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie našich specialit – poctivá kuchyně Hospůdky pod Rablinů."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLACE) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            NAŠE SPECIALITY
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Specialita ${i + 1}`}
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieSpeciality;